import { VAT_RATE_SINCE_2025_07 } from "./vat/vat.js";

export const HETZNER_AMOUNT = 2289;
export const HETZNER_REVERSE_VAT = Math.round(VAT_RATE_SINCE_2025_07 * HETZNER_AMOUNT);
